export const filterPassedTimeForSnooze = (time: Date, currentFacilityDateTime: Date) =>
  currentFacilityDateTime.getTime() < time.getTime();
